import { useMutation, useQueryClient } from "@tanstack/react-query";
import { terminalInventoryKeys } from "Api/Queries/TerminalInventory/useTerminalInventoryListQuery";
import {
  type AddTerminalInventoryItemCommand,
  type ApiProblemDetails,
  type FetchResponse,
  postTerminalInventory,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

// 409 = duplicate serial number.
type AddTerminalInventoryItemError = FetchResponse<ApiProblemDetails, 409>;

type Props = {
  onSuccess?: () => void;
  onError?: (error: AddTerminalInventoryItemError) => void;
};

export const useAddTerminalInventoryItemMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (command: AddTerminalInventoryItemCommand) =>
        postTerminalInventory(command),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: terminalInventoryKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
